import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import SpaceListLayer from "../../components/StorageSpace/SpaceListLayerNew";


const SpaceListPage = () => {
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Storage Space" />

        {/* UsersListLayer */}
        <SpaceListLayer />

      </MasterLayout>

    </>
  );
};

export default SpaceListPage; 
